/** Host-port defaults when DATABASE_PORT / TILES_PORT are unset. Used by the env Zod schema. */
export const DEFAULT_DATABASE_PORT = '5432'
export const DEFAULT_TILES_PORT = '3000'
